export const getToken = () => localStorage.getItem("token");
export const setToken = props => {
  localStorage.setItem("token", props);
};
